export default __webpack_public_path__ + "static/media/woodcut-squid.c0c869de.png";